import navDashboardIcon from 'assets/nav_dashboard_icon.png';

interface Properties {
  width?: number;
  height?: number;
}

const DashboardIcon = ({ width = 16, height = 16 }: Properties) => {
  return (
    <img
      src={navDashboardIcon}
      alt=''
      width={width}
      height={height}
      style={{ filter: 'brightness(0)' }}
    />
  );
};

export default DashboardIcon;
